<template>
  <q-page padding>   
    <q-card> 
    <q-card-title>
      <div class="col">
        <div class="text-h6">Leistungsnachweis</div> 
      </div>
    </q-card-title>
    <q-card-separator />
    <div class="row">
      <div class="col q-pa-md">
        <q-select
          v-model="geoRoot"
          float-label="Geo Region"     
          :options="selectGeoRoot"
          label="Geo Region"
          emit-value map-options
        />
      </div>
    </div>
    <div class="row">
      <div class="col q-pa-md">
          <q-datetime v-model="pDateFrom" type="date" :float-label="$t('global.DateFrom')" format="DD.MMM.YYYY"/>
      </div>
      <div class="col q-pa-md">
        <q-datetime v-model="pDateTo" type="date" :float-label="$t('global.DateTo')" format="DD.MMM.YYYY"/>
      </div>
      </div>
      <div class="row"> 
        <div class="col q-pa-md">
          {{$t('global.Work')}}
          <q-tree
            :nodes="workTree"  
            node-key="IdResource"
            :selected.sync="selectedWork"
            :expanded.sync="propsExpandedWork"
            text-color="leaf"
            :ticked.sync="ticked"
            tick-strategy="strict"
            @update:ticked="updateTicked"
          />
        </div>
      </div>
      <div class="row">
        <div class="col q-pa-md">
          <q-btn :disable="geoRoot == null" :label="$t('global.DownloadExcel')" color="primary" @click="run"/>
        </div>
      </div>
    </q-card>  
  </q-page>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
export default {
  data () {
    return {
      reportName: '',
      uploadUrl: this.$apiGoUrl + "/upload/",
      form: {},   
      IdReport: null,
      selected: [],
      pDateFrom: this.moment().add(-100, 'days').toISOString(),
      pDateTo: this.moment().toISOString(),
      optionReport: [],  
      formfields: [],
      selectType: 1, 
      selectTypeOptions: [
        {
          label: this.$t('global.Yield') ,
          value: 1, 
        },
        {
          label: this.$t('global.WorkJournal') ,
          value: 2, 
        },
        {
          label: 'Geo Kosten' ,
          value: 3, 
        },
        {
          label: 'Produkte Kosten' ,
          value: 4, 
        }
      ],
      excelReportList: [],
      selectedWork: null,
      propsExpandedWork: [],
      workTree: [],
      workTreeFlat: [],
      ticked: [],
      geoRoot: null,
      selectGeoRoot: [],
    }
  },
  methods: {
    dateFormat(val) {
      if(val == null){
        return null
      }
      return this.moment(val).format(this.$store.state.session.DateFormat)
    },
    run(){
      this.form = {}
      if (this.$q.platform.is.ios){
        var windowReference = window.open()
      }
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.DateFrom = this.pDateFrom
      this.form.DateTo = this.pDateTo
      this.form.IdDefaultReport = 2
      this.form.IdGeoRegion = this.geoRoot
      var strRlist = ""
      this.ticked.forEach(element => {
        if (strRlist.length != 0){
          strRlist += ","
        }
        strRlist = strRlist + element
      })
      this.form.rlist = strRlist
      axios.post(this.$apiGoUrl + "/excel/",
      qs.stringify(this.form),
      {
          responseType: 'blob', 
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then((response) => {
          const url = URL.createObjectURL(new Blob([response.data], {
              type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', "Excel.xlsx")
          document.body.appendChild(link)
          link.click()
      })
      .catch(e => {
        this.loading = false
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },

    loadResourceTree(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getResourceTree"
      this.form.OnlyWorkSelectable = false 
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              //this.propsExpanded.push(response.data[0].IdGeoRegion) //Open expand first node
              this.workTree = response.data
              this.makeWorkTreeFlat(response.data)
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    makeWorkTreeFlat(elements){ 
      elements.forEach(element => {
        this.workTreeFlat[element.IdResource] = { Label: element.label }
        //recursive call:
        this.makeWorkTreeFlat(element.children)
      })
    },


    loadGeoRoot(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetGeoRoot"
      axios.post(this.$apiGoUrl + "/excelreport/",
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          if(response.status == 200){ 
              this.selectGeoRoot = response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },




    updateTicked(value){
      console.log(value)
    }

  },

  created () {
    this.loadResourceTree()
    this.loadGeoRoot()
  }
}
</script>
<style scoped>
.secondCard{
  margin-top: 20px;
}

</style>
